import styles from './CardRounded.module.scss';
import Button from '../Button/ButtonComponent';
import { ReactSVG } from 'react-svg';
import { dataResources } from '@portal-internet/core';
import { useRedl } from 'hooks/useRedl';

const { basePath } = dataResources;

export default function CardRoundedComponent(props) {
    const { setShowRightSidePanel } = useRedl();

    const onCancel = () => {
        if (props.onCancel) {
            props.onCancel();
        } else {
            setShowRightSidePanel(prevState => ({ ...prevState, size: 'md', data: undefined, action: 'add' }));
        }
    };

    return (
        <div className={`${styles.redlCardRounded} ${props.action === 'edit' ? styles.redlCardRoundedIn : ''}`} style={props.height ? { height: props.height } : null}>
            {props.header}
            {props.closed ?
                <div className={styles.redlCardRoundedClosed}>
                    <Button variant="tertiary" size="sm" onClick={onCancel}>
                        <ReactSVG src={basePath + '/_resources/REDL/icons/x.svg?v=JIT_ENV_RESOURCES_VERSION'} />
                    </Button>
                </div>
                : null}
            <div className={styles.redlCardRoundedContent}>
                {props.children}
            </div>
        </div>
    );
}